/** Fixed header: transparent over hero until scroll threshold. */
export function initSiteHeader(): void {
  const header = document.getElementById("site-header");
  if (!header) return;

  const threshold = 32;
  const syncScroll = (): void => {
    header.dataset.scrolled = window.scrollY > threshold ? "true" : "false";
  };

  syncScroll();
  window.addEventListener("scroll", syncScroll, { passive: true });

  const mobileNav = document.getElementById("site-mobile-nav");
  if (!mobileNav) return;

  const syncMobileNav = (): void => {
    const isOpen = !mobileNav.hasAttribute("hidden");
    header.dataset.mobileOpen = isOpen ? "true" : "false";
  };

  syncMobileNav();
  new MutationObserver(syncMobileNav).observe(mobileNav, {
    attributes: true,
    attributeFilter: ["hidden"],
  });
}
